// import { AppBar, Box, Button, Container, Divider, Paper, Stack, Toolbar, Typography, useTheme } from '@mui/material'
// import React, { useContext, useRef, useState } from 'react'
// import { Table } from 'react-bootstrap'
// import generatePDF from 'react-to-pdf';
// import jsPDF from 'jspdf'
// import 'jspdf-autotable';
// import ExportContent from '../ExportContent';
// import Pagination from '../general/Pagination';
// import { PvMonitoringContext } from '../../context/PvMonitoringContext';
// import * as XLSX from 'xlsx';
// import ExportContentPvMonitoring from '../ExportContentPvMonitoring';
// import { AuthenticationContext } from '../../context/AuthenticationContext';
// import { PASS_KEY, WEB_KEY, BaseUrl } from '../../api/AxiosApi'
// import ExportPdf from '../exportPdf/ExportPdf';
// import ExportExcel from '../exportExcel/ExportExcel1';

// // let Radiation;
// // export default function PvViewMoreTable({ radiationName, TableName, onHandleClose, onFullScreen, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
// //     const { palette, spacing, shape: { borderRadius } } = useTheme()
// //     const { PvMnPostStringLoading } = useContext(PvMonitoringContext)
// //     const tableRef = useRef(null);

// //     // console.log('Table', TableData)
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [recordsPerPage] = useState(40);

// //     const indexOfLastRecord = currentPage * recordsPerPage;
// //     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
// //     const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
// //     const nPages = Math.ceil(TableData.length / recordsPerPage)

// //     if (TableData?.length > 0) {
// //         Radiation = TableData[0]
// //     }


// //     function genPDF() {
// //         const textX = 20; // Adjust the X-coordinate as needed
// //         const textY = 20; // Adjust the Y-coordinate as needed
// //         const logoWidth = 50; // Adjust the logo width as needed
// //         const logoHeight = 30; // Adjust the logo height as needed
// //         const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

// //         // Add image dynamically
// //         const imgData = require('../../assets/img/logos/logo 2.png');

// //         // Get the width of the PDF document
// //         const pdfWidth = pdf.internal.pageSize.getWidth();

// //         // Calculate the X-coordinate to center the logo
// //         const logoX = (pdfWidth - logoWidth) / 2;

// //         // Add table content using autotable
// //         pdf.setFontSize(12);
// //         // pdf.text('Solar PowerAmr', textX, textY);

// //         // Add the centered logo
// //         pdf.addImage(imgData, 'JPEG', logoX, textY + 5, logoWidth, logoHeight);

// //         // Add title centered on the page
// //         const title = ` ${radiationName} ${ValueOf2}`;
// //         const titleWidth = pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
// //         const titleX = (pdfWidth - titleWidth) / 2;

// //         pdf.text(title, titleX, textY + 5 + logoHeight + 10);

// //         pdf.autoTable({
// //             html: '#table-to-pdf',
// //             startY: textY + 5 + logoHeight + 20, // Adjust the Y-coordinate as needed
// //         });

// //         // Save or download the PDF
// //         pdf.save(`${TableName} To ${ValueOf2}.pdf`);
// //     }

// //     const exportToExcel = () => {
// //         const ws = XLSX.utils.json_to_sheet(TableData);
// //         const wb = XLSX.utils.book_new();
// //         XLSX.utils.book_append_sheet(wb, ws, "PV Parameter Report");
// //         XLSX.writeFile(wb, `PV Parameter To ${ValueOf2} ${TableName}.xlsx`);
// //     };


// //     return (
// //         <>
// //             <>
// //                 <AppBar sx={{ position: 'fixed' }}>
// //                     <Toolbar sx={{ justifyContent: "end", columnGap: spacing(1) }}>
// //                         <Typography variant='h6' flexGrow={1}>  {`Pv Parameter (${TableName})`}  </Typography>

// //                         <ExportContentPvMonitoring
// //                             excelTableRef={exportToExcel}
// //                             onGenPdf={genPDF}
// //                             ExcelExportFileName={`${TableName} To ${ValueOf2}`}
// //                             title={radiationName}
// //                             onFullScreen={onFullScreen}
// //                             filterContent={
// //                                 <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
// //                                     <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
// //                                         <input type='datetime-local' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
// //                                         <Typography variant='body1' >To</Typography>
// //                                         <input type='datetime-local' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
// //                                         <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
// //                                     </Box>
// //                                 </Stack>
// //                             }
// //                         />

// //                         <Button autoFocus color='inherit' variant='outlined' onClick={onHandleClose}>
// //                             Close
// //                         </Button>
// //                     </Toolbar>
// //                 </AppBar>
// //                 <Box>
// //                     {
// //                         PvMnPostStringLoading ? <Typography variant='body2' textAlign={'center'}>Data Loading.......</Typography>
// //                             : currentRecords?.length > 0 ?
// //                                 <>
// //                                     <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
// //                                         <thead style={{}}>
// //                                             <tr style={{ textAlign: 'center' }}>
// //                                                 {
// //                                                     TableHead?.map((item, index) => {
// //                                                         return (
// //                                                             <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
// //                                                         )
// //                                                     })
// //                                                 }
// //                                             </tr>
// //                                         </thead>
// //                                         <tbody>
// //                                             {
// //                                                 currentRecords?.map((item, index) => {
// //                                                     // console.log('data', item)
// //                                                     return (
// //                                                         <tr key={index}>
// //                                                             {TableHead.map(key =>
// //                                                                 <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
// //                                                             )}
// //                                                         </tr>
// //                                                     )
// //                                                 })
// //                                             }
// //                                         </tbody>
// //                                     </Table>
// //                                     <Box
// //                                         sx={{ display: 'flex', justifyContent: 'end' }}
// //                                     >
// //                                         <Pagination
// //                                             nPages={nPages}
// //                                             currentPage={currentPage}
// //                                             setCurrentPage={setCurrentPage}
// //                                         // scrollToBottom={scrollToBottom}
// //                                         />

// //                                     </Box>
// //                                 </>
// //                                 :
// //                                 <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>


// //                     }




// //                 </Box>
// //             </>



// //         </ >
// //     )
// // }



// let Radiation;
// export default function PvViewMoreTable({ radiationName, TableName, onHandleClose, onFullScreen, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext)
//     const { palette, spacing, shape: { borderRadius } } = useTheme()
//     const { PvMnPostStringLoading } = useContext(PvMonitoringContext)
//     const tableRef = useRef(null);

//     // console.log('Table', TableData)
//     const [currentPage, setCurrentPage] = useState(1);
//     // const [recordsPerPage] = useState(40);
//     const [itemsPerPage, setItemsPerPage] = useState(40);

//     const indexOfLastRecord = currentPage * itemsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - itemsPerPage;
//     const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
//     const nPages = Math.ceil(TableData.length / itemsPerPage);

//     const LOGIN_ID = localStorage.getItem('LoginID')

//     const LOC_CODE = LoggedInUserInfo?.Loc_Code;

//     if (TableData?.length > 0) {
//         Radiation = TableData[0]
//     }

//     const logo = require('../../assets/img/logos/logo 2.png');

//     const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`


//     const genPDF = async () => {
//         await ExportPdf(
//             ImageUrl,
//             TableData,
//             ValueOf1,
//             ValueOf2,
//             `${TableName}`,
//             LoggedInUserInfo,
//             logo,
//             TableHead

//         );
//     };



//     const exportToExcel = async () => {
//         await ExportExcel(
//             ImageUrl,
//             TableData,
//             ValueOf1,
//             ValueOf2,
//             `${TableName}`,
//             LoggedInUserInfo
//         );
//     };


//     return (
//         <>
//             <>
//                 <AppBar sx={{ position: 'fixed' }}>
//                     <Toolbar sx={{ justifyContent: "end", columnGap: spacing(1) }}>

//                         <Typography variant='h6' flexGrow={1}>  {`Pv Parameter (${TableName}) `}
//                             <select
//                                 id="entries"
//                                 value={itemsPerPage}
//                                 onChange={(e) => {
//                                     setItemsPerPage(Number(e.target.value));
//                                     setCurrentPage(1);
//                                 }}
//                                 style={{ padding: '4px', fontSize: '14px' }}
//                             >
//                                 <option value={10}>10</option>
//                                 <option value={20}>20</option>
//                                 <option value={30}>30</option>
//                                 <option value={40}>40</option>
//                                 <option value={50}>50</option>

//                                 <option value={TableData.length}>All</option>
//                             </select>&nbsp;
//                             <span style={{ fontSize: "1.3rem" }}>entries</span>

//                         </Typography>

//                         <ExportContentPvMonitoring
//                             excelTableRef={exportToExcel}
//                             onGenPdf={genPDF}
//                             ExcelExportFileName={`${TableName} To ${ValueOf2}`}
//                             title={radiationName}
//                             onFullScreen={onFullScreen}
//                             filterContent={
//                                 <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>

//                                     <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
//                                         <input type='datetime-local' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
//                                         <Typography variant='body1' >To</Typography>
//                                         <input type='datetime-local' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
//                                         <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
//                                     </Box>
//                                 </Stack>
//                             }
//                         />

//                         <Button autoFocus color='inherit' variant='outlined' onClick={onHandleClose}>
//                             Close
//                         </Button>
//                     </Toolbar>
//                 </AppBar>
//                 <Box>
//                     {
//                         PvMnPostStringLoading ? <Typography variant='body2' textAlign={'center'}>Data Loading.......</Typography>
//                             : currentRecords?.length > 0 ?
//                                 <>
//                                     <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
//                                         <thead style={{}}>
//                                             <tr style={{ textAlign: 'center' }}>
//                                                 {
//                                                     TableHead?.map((item, index) => {
//                                                         return (
//                                                             <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
//                                                         )
//                                                     })
//                                                 }
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {
//                                                 currentRecords?.map((item, index) => {
//                                                     // console.log('data', item)
//                                                     return (
//                                                         <tr key={index}>
//                                                             {TableHead.map(key =>
//                                                                 <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
//                                                             )}
//                                                         </tr>
//                                                     )
//                                                 })
//                                             }
//                                         </tbody>
//                                     </Table>
//                                     <Box
//                                         sx={{ display: 'flex', justifyContent: 'end' }}
//                                     >
//                                         <Pagination
//                                             nPages={nPages}
//                                             currentPage={currentPage}
//                                             setCurrentPage={setCurrentPage}
//                                         // scrollToBottom={scrollToBottom}
//                                         />

//                                     </Box>
//                                 </>
//                                 :
//                                 <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>


//                     }




//                 </Box>
//             </>



//         </ >
//     )
// }



import { AppBar, Box, Button, Container, Divider, Paper, Stack, Toolbar, Typography, useTheme } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { Table } from 'react-bootstrap'
import generatePDF from 'react-to-pdf';
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import ExportContent from '../ExportContent';
import Pagination from '../general/Pagination';
import { PvMonitoringContext } from '../../context/PvMonitoringContext';
import * as XLSX from 'xlsx';
import ExportContentPvMonitoring from '../ExportContentPvMonitoring';
import { AuthenticationContext } from '../../context/AuthenticationContext';
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../api/AxiosApi'
import ExportPdf from '../exportPdf/ExportPdf';
import ExportExcel from '../exportExcel/ExportExcel1';

// let Radiation;
// export default function PvViewMoreTable({ radiationName, TableName, onHandleClose, onFullScreen, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
//     const { palette, spacing, shape: { borderRadius } } = useTheme()
//     const { PvMnPostStringLoading } = useContext(PvMonitoringContext)
//     const tableRef = useRef(null);

//     // console.log('Table', TableData)
//     const [currentPage, setCurrentPage] = useState(1);
//     const [recordsPerPage] = useState(40);

//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
//     const nPages = Math.ceil(TableData.length / recordsPerPage)

//     if (TableData?.length > 0) {
//         Radiation = TableData[0]
//     }


//     function genPDF() {
//         const textX = 20; // Adjust the X-coordinate as needed
//         const textY = 20; // Adjust the Y-coordinate as needed
//         const logoWidth = 50; // Adjust the logo width as needed
//         const logoHeight = 30; // Adjust the logo height as needed
//         const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

//         // Add image dynamically
//         const imgData = require('../../assets/img/logos/logo 2.png');

//         // Get the width of the PDF document
//         const pdfWidth = pdf.internal.pageSize.getWidth();

//         // Calculate the X-coordinate to center the logo
//         const logoX = (pdfWidth - logoWidth) / 2;

//         // Add table content using autotable
//         pdf.setFontSize(12);
//         // pdf.text('Solar PowerAmr', textX, textY);

//         // Add the centered logo
//         pdf.addImage(imgData, 'JPEG', logoX, textY + 5, logoWidth, logoHeight);

//         // Add title centered on the page
//         const title = ` ${radiationName} ${ValueOf2}`;
//         const titleWidth = pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
//         const titleX = (pdfWidth - titleWidth) / 2;

//         pdf.text(title, titleX, textY + 5 + logoHeight + 10);

//         pdf.autoTable({
//             html: '#table-to-pdf',
//             startY: textY + 5 + logoHeight + 20, // Adjust the Y-coordinate as needed
//         });

//         // Save or download the PDF
//         pdf.save(`${TableName} To ${ValueOf2}.pdf`);
//     }

//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(TableData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "PV Parameter Report");
//         XLSX.writeFile(wb, `PV Parameter To ${ValueOf2} ${TableName}.xlsx`);
//     };


//     return (
//         <>
//             <>
//                 <AppBar sx={{ position: 'fixed' }}>
//                     <Toolbar sx={{ justifyContent: "end", columnGap: spacing(1) }}>
//                         <Typography variant='h6' flexGrow={1}>  {`Pv Parameter (${TableName})`}  </Typography>

//                         <ExportContentPvMonitoring
//                             excelTableRef={exportToExcel}
//                             onGenPdf={genPDF}
//                             ExcelExportFileName={`${TableName} To ${ValueOf2}`}
//                             title={radiationName}
//                             onFullScreen={onFullScreen}
//                             filterContent={
//                                 <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
//                                     <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
//                                         <input type='datetime-local' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
//                                         <Typography variant='body1' >To</Typography>
//                                         <input type='datetime-local' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
//                                         <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
//                                     </Box>
//                                 </Stack>
//                             }
//                         />

//                         <Button autoFocus color='inherit' variant='outlined' onClick={onHandleClose}>
//                             Close
//                         </Button>
//                     </Toolbar>
//                 </AppBar>
//                 <Box>
//                     {
//                         PvMnPostStringLoading ? <Typography variant='body2' textAlign={'center'}>Data Loading.......</Typography>
//                             : currentRecords?.length > 0 ?
//                                 <>
//                                     <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
//                                         <thead style={{}}>
//                                             <tr style={{ textAlign: 'center' }}>
//                                                 {
//                                                     TableHead?.map((item, index) => {
//                                                         return (
//                                                             <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
//                                                         )
//                                                     })
//                                                 }
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {
//                                                 currentRecords?.map((item, index) => {
//                                                     // console.log('data', item)
//                                                     return (
//                                                         <tr key={index}>
//                                                             {TableHead.map(key =>
//                                                                 <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
//                                                             )}
//                                                         </tr>
//                                                     )
//                                                 })
//                                             }
//                                         </tbody>
//                                     </Table>
//                                     <Box
//                                         sx={{ display: 'flex', justifyContent: 'end' }}
//                                     >
//                                         <Pagination
//                                             nPages={nPages}
//                                             currentPage={currentPage}
//                                             setCurrentPage={setCurrentPage}
//                                         // scrollToBottom={scrollToBottom}
//                                         />

//                                     </Box>
//                                 </>
//                                 :
//                                 <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>


//                     }




//                 </Box>
//             </>



//         </ >
//     )
// }



let Radiation;
export default function PvViewMoreTable({ radiationName, TableName, onHandleClose, onFullScreen, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const { PvMnPostStringLoading } = useContext(PvMonitoringContext)
    const tableRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');


    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    // const [recordsPerPage] = useState(40);
    const [itemsPerPage, setItemsPerPage] = useState(40);



    const indexOfLastRecord = currentPage * itemsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - itemsPerPage;

    const filteredData = TableData.filter(item =>
        TableHead.some(key =>
            item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(filteredData.length / itemsPerPage);


    const LOGIN_ID = localStorage.getItem('LoginID')

    const LOC_CODE = LoggedInUserInfo?.Loc_Code;

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }

    const logo = require('../../assets/img/logos/logo 2.png');

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`


    const genPDF = async () => {
        await ExportPdf(
            ImageUrl,
            TableData,
            ValueOf1,
            ValueOf2,
            `${TableName}`,
            LoggedInUserInfo,
            logo,
            TableHead

        );
    };



    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            TableData,
            ValueOf1,
            ValueOf2,
            `${TableName}`,
            LoggedInUserInfo
        );
    };


    return (
        <>
            <>
                <AppBar sx={{ position: 'fixed' }}>
                    <Toolbar sx={{ justifyContent: "end", columnGap: spacing(1) }}>

                        {/* <Typography variant='h6' flexGrow={1}>  {`Pv Parameter (${TableName}) `} */}
                         <Typography variant='h6' flexGrow={1}>  {` (${TableName}) `}
                            <select
                                id="entries"
                                value={itemsPerPage}
                                onChange={(e) => {
                                    setItemsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{ padding: '4px', fontSize: '14px' }}
                            >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>

                                <option value={TableData.length}>All</option>
                            </select>&nbsp;
                            <span style={{ fontSize: "1.3rem" }}>entries</span>

                        </Typography>

                        <ExportContentPvMonitoring
                            excelTableRef={exportToExcel}
                            onGenPdf={genPDF}
                            ExcelExportFileName={`${TableName} To ${ValueOf2}`}
                            title={radiationName}
                            onFullScreen={onFullScreen}
                            filterContent={
                                <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>

                                    <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                        <input
                                            type='text'
                                            placeholder='Search...'
                                            value={searchTerm}
                                            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                                            style={{ padding: '1px 8px', fontSize: '14px', width: '150px',borderRadius:"4px" }}
                                        />
                                        <input type='datetime-local' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                                        <Typography variant='body1' >To</Typography>
                                        <input type='datetime-local' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                                        <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                                    </Box>

                                </Stack>
                            }
                        />

                        <Button autoFocus color='inherit' variant='outlined' onClick={onHandleClose}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <Box>
                    {
                        PvMnPostStringLoading ? <Typography variant='body2' textAlign={'center'}>Data Loading.......</Typography>
                            : currentRecords?.length > 0 ?
                                <>
                                    <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
                                        <thead style={{}}>
                                            <tr style={{ textAlign: 'center' }}>
                                                {
                                                    TableHead?.map((item, index) => {
                                                        return (
                                                            <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentRecords?.map((item, index) => {
                                                    // console.log('data', item)
                                                    return (
                                                        <tr key={index}>
                                                            {TableHead.map(key =>
                                                                <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
                                                            )}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    <Box
                                        sx={{ display: 'flex', justifyContent: 'end' }}
                                    >
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                        // scrollToBottom={scrollToBottom}
                                        />

                                    </Box>
                                </>
                                :
                                <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>


                    }




                </Box>
            </>



        </ >
    )
}